import React, { useEffect, useState } from "react"
import ClientReportCard from "../../components/ClientReportCard.molecule"
import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded"
import PrimaryButton from "../../../../components/molecules/buttons/PrimaryButton.molecule"
import { getClientSprintDetailedEstimationBySprintId } from "../../../../services/clientReport.service"
import { formatSprintDetailedEstimationData } from "../../../../utils/clientReport.utils"
import SprintDetailedEstimationChart from "../../components/SprintDetailedEstimationChart.compound"
import ModalFormEditClientEstimation from "../../components/ModalFormEditClientEstimation.compound"
import { useSession } from "../../../../hooks/auth/useSession.hook"
import {
  CLIENT_SPRINT_CARD_MODES,
  CLIENT_SPRINT_STATES,
} from "../../../../consts/modules/clientReport.consts"

const ClientSprintDetailedEstimation = ({
  refresh,
  triggerRefresh,
  sprintData,
  mode = CLIENT_SPRINT_CARD_MODES.EDITABLE,
  refChart,
  collapsible = false,
}) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [visibleEditEstimationModal, setVisibleEditEstimationModal] =
    useState(false)

  const { user } = useSession()

  useEffect(() => {
    fetchSprintDetailedEstimation(sprintData?.id)
  }, [sprintData, refresh])

  /** @param {number} sprintId */
  const fetchSprintDetailedEstimation = async (sprintId) => {
    if (!sprintId) {
      setData(null)
      setLoading(false)
      return
    }

    setLoading(true)
    try {
      const response =
        await getClientSprintDetailedEstimationBySprintId(sprintId)

      if (!response?.success) {
        throw new Error(
          response?.message || "Error al obtener la estimación detallada"
        )
      }

      setData(response?.result || null)
    } catch (error) {
      console.error("Error fetching sprint detailed estimation:", error)
      setData(null)
    } finally {
      setLoading(false)
    }
  }

  const isEditableMode = mode === CLIENT_SPRINT_CARD_MODES.EDITABLE

  return (
    <>
      <ClientReportCard
        collapsible={collapsible}
        title={"Estimación detallada"}
        headerButton={
          (user?.isAdmin() ||
            (sprintData?.state === CLIENT_SPRINT_STATES.IN_PROGRESS &&
              user?.isTeamLeader())) &&
          isEditableMode && (
            <PrimaryButton
              btnType="outlined"
              label={"Editar"}
              icon={`pi pi-pencil`}
              onClick={() => setVisibleEditEstimationModal(true)}
            />
          )
        }
        icon={
          <ManageSearchRoundedIcon
            className="clr-primary-highlight"
            fontSize="large"
          />
        }
        className="flex-1 font-cairo flex-shrink-0 w-full"
      >
        <SprintDetailedEstimationChart
          data={formatSprintDetailedEstimationData(data)}
          loading={loading}
          refChart={refChart}
        />
      </ClientReportCard>
      {!!isEditableMode && (
        <ModalFormEditClientEstimation
          visible={visibleEditEstimationModal}
          setVisible={setVisibleEditEstimationModal}
          sprintData={sprintData}
          onComplete={() => {
            setVisibleEditEstimationModal(false)
            triggerRefresh()
          }}
        />
      )}
    </>
  )
}

export default ClientSprintDetailedEstimation
